module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Vincent-and-the-Grenadines-c5c8579bb2c2f88613af41d50634985e.png";